import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import GoogleExplore from "components/Next/Google/GoogleExplore";

import * as runReducer from "containers/Run/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as wizardReducer from "containers/Wizard/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as homeReducer from "containers/Home/reducer";
import * as deploymentsReducer from "containers/Deployments/reducer";
import * as predictReducer from "containers/Predict/reducer";
import * as viewReducer from "containers/View/reducer";
import * as globalReducer from "containers/App/reducer";
import * as projectReducer from "containers/Project/reducer";
import * as loginReducer from "containers/Login/reducer";
import * as uploadReducer from "containers/Upload/reducer";
import * as accountsReducer from "containers/Accounts/reducer";
import * as galleryReducer from "containers/Gallery/GalleryReducer";
import * as nextReducer from "containers/Next/NextReducer";

import { PROJECT_MODES } from "containers/Run/reducer";

import { isEnabled } from "utils/featureFlags";

const getNextId = (props) =>
  props && props.nextId !== undefined
    ? props.nextId
    : props && props.match && props.match.params && props.match.params.nextId !== undefined
      ? props.match.params.nextId
      : "new";

const getDatasetId = (props) =>
  props && props.datasetId !== undefined ? props.datasetId : props?.match?.params?.datasetId;

class GoogleExploreContainer extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {};

    props.nextInit(props.datasetId).then(() => {
      props.updateSearchType("All Insights");

      this.searchWaiter();
    });
  }

  searchWaiter() {
    const { isExploreReady, nextInit, initGrid, datasetId } = this.props;

    if (isExploreReady === true) {
      return initGrid();
    } else {
      return setTimeout(() => this.searchWaiter(), 200);
    }
  }

  render() {
    return this.props.isExploreReady !== true ? (
      <div
        style={{
          height: "calc(100vh - 60px)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <LoadingIndicator style={{ margin: "0px" }} />
      </div>
    ) : (
      <GoogleExplore {...this.props} />
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const nextId = getNextId(ownProps);

  return {
    handleTableauUpload: () => dispatch(loginReducer.handleTableauUpload()),

    handleSearchInsights: (options) => dispatch(nextReducer.handleSearchInsights(nextId, options)),
    updateSearchType: (searchType) => dispatch(nextReducer.updateSearchType(nextId, searchType, false)),
    updateTableauDataId: (tableauDataId) => dispatch(nextReducer.updateTableauDataId(nextId, tableauDataId)),
    nextInit: (datasetId) => dispatch(nextReducer.init(nextId, datasetId, true)),

    initGrid: () => dispatch(nextReducer.initGrid(nextId))
  };
};

const mapStateToProps = (state, ownProps) => {
  const nextId = getNextId(ownProps);
  const datasetId = getDatasetId(ownProps);

  return {
    nextId: nextId,
    datasetId: datasetId,

    dataset: homeReducer.getDataset(state, datasetId),
    isExploreReady: homeReducer.getIsExploreReady(state, datasetId),

    nextSearchInsights: nextReducer.getSearchInsights(state, nextId),

    tableauDataId: loginReducer.getTableauDataId(state),
    nextTableauDataId: nextReducer.getTableauDataId(state, nextId)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(GoogleExploreContainer);
